export enum ProcessActivityExternalPerformerName {
    caro = 'caro',
    cloudPat = 'cloudPat',
    dgtlHealth = 'dgtlHealth',
    evidencio = 'evidencio',
    fysiologic = 'fysiologic',
    mijnKsyos = 'mijnKsyos',
}
